import React from "react";
import { Link } from "react-router-dom";
import apps, { CONTACT_EMAIL } from "../data/apps";
import PlayBadge from "../components/PlayBadge";

export default function HomePage() {
  return (
    <>
      <section className="hero">
        <div className="container hero-inner">
          <img src="/logo512.png" alt="Northwind logo" width={120} height={120} />
          <h1>
            Northwind <span className="accent">Apps</span>
          </h1>
          <p className="lead">
            Small, focused mobile apps for creating, designing and tinkering.
            Built for Android.
          </p>
        </div>
      </section>

      <section className="container section" id="apps">
        <h2>Our apps</h2>
        <div className="app-grid">
          {apps.map((app) => (
            <article className="card app-card" key={app.slug}>
              <Link to={`/apps/${app.slug}`} className="app-card-head">
                <img src={app.icon} alt={`${app.name} icon`} width={72} height={72} />
                <div>
                  <h3>{app.name}</h3>
                  <div className="muted">{app.category}</div>
                </div>
              </Link>
              <p>{app.summary}</p>
              <div className="card-actions">
                <Link to={`/apps/${app.slug}`} className="btn">
                  Learn more
                </Link>
                <PlayBadge url={app.playStoreUrl} />
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="container section" id="contact">
        <h2>Contact</h2>
        <div className="card">
          <p>
            Questions, feedback or bug reports? Email us and we'll get back to
            you.
          </p>
          <a className="btn btn-primary" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
        </div>
      </section>
    </>
  );
}
